import { PageType } from '@tvg/product-listing-url/lib/Types/types';

export enum FacetType {
  Brand = 'brand',
  Colours = 'colours',
  NavColour = 'navigationColour',
  Category = 'category',
  Department = 'department',
  Rating = 'customerRating',
}

export enum SortOption {
  Relevance = 'relevance',
  Brand = 'brand',
  HighestRated = 'highestrated',
  NewIn = 'newin',
  PriceDesc = 'pricedesc',
  Price = 'price',
}

export const SortOptionsMap = {
  [SortOption.Relevance]: ['relevance', 'descending'],
  [SortOption.Brand]: ['brand_name', 'ascending'],
  [SortOption.HighestRated]: ['rating', 'descending'],
  [SortOption.NewIn]: ['new_in', 'descending'],
  [SortOption.PriceDesc]: ['price', 'descending'],
  [SortOption.Price]: ['price', 'ascending'],
} as const;

export const PageTypeFilterMap = {
  [PageType.browse]: 'group_id',
  [PageType.promo]: 'collection_id',
  [PageType.valuedeal]: 'collection_id',
  [PageType.search]: '',
};
